import React from 'react';
import {Box, Text} from '@chakra-ui/react';
import {ObjectId} from 'bson';
import {useScoringRun} from '../../../context/ScoringRunContext';
import {AccountWithLogo} from '../../../shared/scoredAccounts';
import {FilterSelect} from './FilterSelect';
import {FilterControlWithNegate} from './FilterControlWithNegate';
import {CompanyLogo} from '../../Icons/CompanyLogo';

export const SimilarAccountsFilterControl = ({
  value,
  negate,
  onChange,
  onRemove,
}: {
  value: ObjectId[];
  negate?: boolean;
  onChange: (value: ObjectId[], negate?: boolean) => void;
  onRemove: () => void;
}) => {
  const scoringRun = useScoringRun();
  const lookalikesWithLogos = scoringRun?.lookalikesWithLogos;
  const selectedSimilarTo = lookalikesWithLogos?.filter((lookalike) =>
    value.find((id) => id.equals(lookalike._id))
  );

  if (!lookalikesWithLogos) {
    return null;
  }

  return (
    <FilterControlWithNegate
      value={value}
      negate={negate}
      onChange={onChange}
      onRemove={onRemove}
    >
      {(_, onValueChange) => (
        <FilterSelect
          noOptionsMessage={() => 'No similar accounts.'}
          options={lookalikesWithLogos?.map((lookalike) => ({
            value: lookalike,
            label: lookalike.name,
          }))}
          isMulti
          formatOptionLabel={formatLookalikeOptionLabel}
          value={selectedSimilarTo?.map((lookalike) => ({
            value: lookalike,
          }))}
          onChange={(values) => {
            onValueChange(values.map((v) => v.value._id));
          }}
        />
      )}
    </FilterControlWithNegate>
  );
};

const formatLookalikeOptionLabel = ({value}: {value: AccountWithLogo}) => {
  return (
    <Box display="flex" alignItems="center" mt="0">
      <CompanyLogo
        domain={value.domain}
        name={value.name}
        boxSize="20px"
        mr="2"
      />
      <Text fontSize="12px">{value.name}</Text>
    </Box>
  );
};
